import React, {Component} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PasswordChangeForm from './PasswordChangeForm';
import * as userActions from '../actions/UserActions';
import {getTranslate, getActiveLanguage} from 'react-localize-redux';

class PasswordChangePage extends Component {
    componentDidMount() {
      this.props.resetForm();
    }

    render() {
        const {changePassword} = this.props.userActions;
        return (
            <PasswordChangeForm
                changePassword={changePassword}
                user={this.props.user}
                formStatus={this.props.formStatus}
                translate={this.props.translate}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        login: state.user.login,
        formStatus: state.formStatus,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    }
}

function mapDispatchToProps(dispatch) {
    return {
        resetForm: () => dispatch({ type: 'RESET_FORM' }),
        userActions: bindActionCreators(userActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PasswordChangePage);



// WEBPACK FOOTER //
// ./src/components/PasswordChangePage.js